VLW.eavVinPIXIDisplacement = class extends VLW.classBase {
	constructor() {
		super();
		this.align              = "";
		this.mainContainer      = new PIXI.Container();
		this.mainContainer.name = "displacementMainContainer";
		this.cpt                = 0;
	}
	onMousemove(e){
		TweenMax.to(this.spriteImageMateriel_1,.5,{x: this.spriteImageMateriel_1.xOr+-5*window.mousePosition.rationMiddle.x,y:this.spriteImageMateriel_1.yOr+-5*window.mousePosition.rationMiddle.y})
		TweenMax.to(this.spriteImageMateriel_2,.75,{x: this.spriteImageMateriel_2.xOr+-15*window.mousePosition.rationMiddle.x,y:this.spriteImageMateriel_2.yOr+-15*window.mousePosition.rationMiddle.y})
	}
	
	set resources(resources) {
		this._resources                 = resources;
		this.spriteImage                = new PIXI.Sprite(this._resources.image.texture);
		this.spriteImageMateriel_1      = new PIXI.Sprite(this._resources.imageMaterial.texture);
		this.spriteImageMateriel_2      = new PIXI.Sprite(this._resources.imageMaterial.texture);
		this.maskBouteille              = new PIXI.Sprite(this._resources.mask_bouteille.texture);
		this.maskTable                  = new PIXI.Sprite(this._resources.mask_table.texture);
		this.spriteImageMateriel_1.mask = this.maskBouteille;
		this.spriteImageMateriel_2.mask = this.maskTable;
		this.spriteImage.size 			= this.spriteImageMateriel_1.size = this.spriteImageMateriel_2.size = this.maskBouteille.size = this.maskTable.size = this.mainContainer.size = {width: this.spriteImage.width, height: this.spriteImage.height};
		this.mainContainer.addChild(this.spriteImage);
		this.mainContainer.addChild(this.spriteImageMateriel_1);
		this.mainContainer.addChild(this.spriteImageMateriel_2);
		this.mainContainer.addChild(this.maskTable);
		this.mainContainer.addChild(this.maskBouteille);
		document.addEventListener("mousemove"	, this.onMousemove	, supportsPassive);
	}
	
	render() {
		this.cpt++;
	}
	
	size() {
		
		let ratioX = Math.min(1,Math.round((windowSize.width/1440)*1e2)/1e2);
		let ratioY = Math.min(1,Math.round((windowSize.height/900)*1e2)/1e2);
		let ration = Math.min(ratioX,ratioY);
		
		this.spriteImageMateriel_1	.scale.set(ration,ration);
		this.maskBouteille			.scale.set(ration,ration);
		this.setFullScreen(this.spriteImage,this.maskTable,this.spriteImageMateriel_2);
		this.spriteImageMateriel_2.scale.set(this.spriteImageMateriel_2.scale.x+.2,this.spriteImageMateriel_2.scale.y+.2);
		this.maskTable.scale.set(this.spriteImageMateriel_2.scale.x,this.spriteImageMateriel_2.scale.y);
		
		this.spriteImageMateriel_1.position.set(windowSize.width*.1, (this.spriteImageMateriel_1.height - windowSize.height) * -.9);
		this.spriteImageMateriel_2.position.set((this.spriteImageMateriel_2.width - windowSize.width) * -1, (this.spriteImageMateriel_2.height - windowSize.height) * -0.95);
		
		this.maskTable.position		.set(this.spriteImageMateriel_2.x,this.spriteImageMateriel_2.y);
		this.maskBouteille.position	.set(this.spriteImageMateriel_1.x,this.spriteImageMateriel_1.y);
		
		this.setPositionOr(this.spriteImageMateriel_1);
		this.setPositionOr(this.spriteImageMateriel_2);
		
	}
	
	setPositionOr(elt){
		elt.xOr = elt.position.x;
		elt.yOr = elt.position.y;
		
	}
	
	setFullScreen(...aElt) {
		aElt.forEach(elt => {
			let ratio  = Math.max(windowSize.width / elt.size.width, windowSize.height / elt.size.height);
			elt.width  = Math.round(elt.size.width  * ratio);
			elt.height = Math.round(elt.size.height * ratio);
		});
	}
	
	instanceClean() {
		document.removeEventListener("mousemove"	, this.onMousemove);
		try {
			TweenMax.killTweensOf(this.spriteImageMateriel_1);
			TweenMax.killTweensOf(this.spriteImageMateriel_2);
			this.mainContainer.renderable = false;
			PIXIAPP.app.stage.removeChild(this.mainContainer);
			this.mainContainer.removeChild(this.spriteImage, this.spriteImageMateriel_1, this.spriteImageMateriel_2, this.maskTable, this.maskBouteille);
			this.mainContainer.destroy({children: true, texture: true, baseTexture: true});
			this.spriteImage.destroy({children: true, texture: true, baseTexture: true});
			this.spriteImageMateriel_1.destroy({children: true, texture: true, baseTexture: true});
			this.spriteImageMateriel_2.destroy({children: true, texture: true, baseTexture: true});
			this.maskBouteille.destroy({children: true, texture: true, baseTexture: true});
			this.maskTable.destroy({children: true, texture: true, baseTexture: true});
		}catch (e) {
			console.log(e);
			
		}
		
		super.instanceClean();
	}
}